import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import DrPrimaryDialog from '../json-pages/DrPrimaryDialog';
import DrPrimary from '../json-pages/DrPrimary';

const UI = ({ match }) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Route path={`${match.url}/primary-dialog`} component={DrPrimaryDialog} />
      <Route path={`${match.url}/primary`} component={DrPrimary} />
      <Redirect to="/error" />
    </Switch>
  </div>
);
export default UI;
